export default {"src":"/_next/static/media/trust-plan.aa431403.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};